/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Comfort_Timeslot_GenerationInputs */



/**
* | output |
* | --- |
* | "Pre-comfort time slot generation" |
*
* @param {Pre_Comfort_Timeslot_GenerationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pre_comfort_timeslot_generation = /** @type {((inputs?: Pre_Comfort_Timeslot_GenerationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Comfort_Timeslot_GenerationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pre-comfort time slot generation")
	return /** @type {LocalizedString} */ ("Génération de plage de pré-confort")
});